import { gatewayService } from "@/_services/gateway.service";
/**
 * Exposure data, with Fwd Valuation
 * @param {string} fieldName: field name to update
 * @param {boolean} fieldShowLoadingName: Defines if the field must be shown loading
 */
export function readCommodityValuationDataOptimizer(_this, daysToExpiration) {
  return gatewayService.commodities.valuationInputs({
    format: "json",
    commodity: _this.commodityNumber,
    last: 1,
    days_to_expiration: JSON.stringify({ values: daysToExpiration })
  });
}
